// src/pages/TestManagementPage/index.js

import React, { useEffect, useMemo, useState } from 'react';
import { Typography, Tabs } from 'antd';
import { PlusOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';

import CreateTestTab from './CreateTestTab';
import ManageTestsTab from './ManageTestsTab';

const { Title } = Typography;

const TestManagementPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Lấy tab từ query (?tab=manage) hoặc từ location.state.activeTab
  const initialKey = useMemo(() => {
    const sp = new URLSearchParams(location.search);
    const q = sp.get('tab') || (location.state && location.state.activeTab);
    return q === 'manage' ? 'manage' : 'create';
  }, [location.search, location.state]);

  const [activeKey, setActiveKey] = useState(initialKey);

  // Đồng bộ khi user dùng Back/Forward hoặc state thay đổi
  useEffect(() => {
    setActiveKey(initialKey);
  }, [initialKey]);

  const onChange = (key) => {
    setActiveKey(key);
    // Cập nhật URL để giữ tab sau khi refresh / copy link
    const sp = new URLSearchParams(location.search);
    sp.set('tab', key);
    navigate({ pathname: '/tests', search: `?${sp.toString()}` }, { replace: true });
  };

  const tabItems = [
    {
      label: (
        <span>
          <PlusOutlined /> 作成
        </span>
      ),
      key: 'create',
      children: <CreateTestTab />,
    },
    {
      label: (
        <span>
          <UnorderedListOutlined /> 管理・編集
        </span>
      ),
      key: 'manage',
      children: <ManageTestsTab />,
    },
  ];

  return (
    <div>
      <Title level={2}>テスト管理</Title>
      <Tabs
        items={tabItems}
        activeKey={activeKey}
        onChange={onChange}
        destroyInactiveTabPane
      />
    </div>
  );
};

export default TestManagementPage;
